import { Button, Grid, Paper } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import { setNotificationsStatus } from '@webapps/business';
import {
  Modal,
  ModalSideBar,
  useMutation,
  useNotif,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

const RenderDescriptionWithFormatting = ({ description }) => {
  // Fonction pour diviser la description et appliquer le formatage
  const formattedParts = description
    ?.split(/(\*.*?\*|_.*?_|\n|\[image:.*?\])/)
    .filter(Boolean)
    .map((part, index) => {
      if (part.startsWith('*') && part.endsWith('*')) {
        // Pour le texte en gras
        return <strong key={index}>{part.slice(1, -1)}</strong>;
      } else if (part.startsWith('_') && part.endsWith('_')) {
        // Pour le texte en italique
        return <em key={index}>{part.slice(1, -1)}</em>;
      } else if (part === '\n') {
        // Pour les sauts de ligne
        return <br key={index} />;
      } else if (part.startsWith('[image:') && part.endsWith(']')) {
        // Extrait l'URL de l'image du marquage
        const imageUrl = part.slice(7, -1);
        return (
          <img
            key={index}
            src={imageUrl}
            alt=""
            style={{ maxWidth: '3%', height: 'auto', verticalAlign: 'middle' }}
          />
        );
      } else {
        return part;
      }
    });

  return <>{formattedParts}</>;
};

const CardNotification = ({ date, icon: Icon, id, notifData }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const { push } = useRouter();

  const {
    // error: errorSetNotificationStatus,
    // isLoading: isLoadingNotificationStatus,
    // isSuccess: isSuccessSetNotificationStatus,
    mutate: mutateSetNotificationStatus,
  } = useMutation(setNotificationsStatus);

  const { refetch: refetchNotifNumber } = useNotif();

  const goToNotification = async () => {
    await mutateSetNotificationStatus({
      id,
    });
    // push(notifData?.path);
  };

  const goToPage = () => {
    push(notifData?.path);
  };

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
    goToNotification();
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    refetchNotifNumber();
  };

  return (
    notifData?.content !== '' && (
      <Grid style={{ borderRadius: 10, padding: spacing(0, 2.5, 2.5, 0) }}>
        <div className={classes.cardInformation}>
          {/* <div className={classes.firstIconContainer}>{Icon && <Icon />}</div> */}
          <div className={classes.information}>
            <div className={global.title}>{notifData?.title}</div>
            <div className={classes.text}>{notifData?.content}</div>
            <div className={cx(global.infoText, classes.address)}>
              <EventIcon className={classes.imgAdress} />
              <FormattedTime value={new Date(date)} />
              {' le '}
              <FormattedDate
                day="numeric"
                month="long"
                value={date}
                year="numeric"
              />
            </div>
          </div>
          <div className={classes.cardSeeMore}>
            <Button
              className={css({ fontWeight: 600, width: '100%' })}
              variant="outlined"
              onClick={handleOpenModal}
            >
              Voir le détail
            </Button>
          </div>
        </div>
        <Modal
          onCancel={handleCloseModal}
          open={openModal}
          subTitle=""
          title={notifData?.title}
          withStep={false}
        >
          <div className={css({ textAlign: 'center', color: '#152652' })}>
            <RenderDescriptionWithFormatting
              description={notifData?.description}
            />
          </div>
          <div
            className={css({ display: 'flex', justifyContent: 'center' })}
            item
            xs={12}
          >
            <Button
              className={css({
                fontWeight: 600,
                marginTop: spacing(3),
                backgroundColor: 'white',
                height: 30,
                width: 120,
              })}
              color="primary"
              onClick={goToPage}
              variant="outlined"
            >
              Voir
            </Button>
          </div>
        </Modal>
      </Grid>
    )
  );
};

const styles = ({ spacing }) => ({
  cardInformation: {
    padding: spacing(2.5),
    borderRadius: 10,
    borderBottom: '0px solid',
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    columnGap: spacing(2),
  },

  firstIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    height: 65,
    width: 65,

    backgroundColor: '#DAE9FC',
    borderRadius: 100,
    '& > *': {
      height: 35,
      width: 35,

      color: '#0060F9',
    },
  },
  text: {
    color: '#152652',
    lineHeight: '110%',

    marginTop: spacing(1.5),
  },
  cardSeeMore: {
    paddingTop: spacing(2.5),
    borderRadius: 0,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    backgroundColor: '#FFF',
    textAlign: 'center',
    color: '#5A6DA1',
    fontWeight: 600,
    fontFamily: 'Montserrat',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(1.5),
  },
  imgAdress: {
    '@media only screen and (max-width:1920px)': { fontSize: '15.0px' },
    '@media only screen and (max-width:1600px)': { fontSize: '15px' },
    marginRight: spacing(1),
  },
});

CardNotification.propTypes = {
  icon: PropTypes.elementType,
  notifData: PropTypes.object,
  date: PropTypes.string,
  id: PropTypes.string,
  refetch: PropTypes.func,
};

export default CardNotification;
